import { Injectable } from '@angular/core';
import {   Response, Headers } from '@angular/http';

import "rxjs/add/operator/map"
import { Observable } from 'rxjs/Observable';


import { Mails } from '../entity/Mails';
import { Pjoint, Modelcores } from '../entity/Pjoint';
import { Prospect } from '../entity/prospect';
import { Staff } from '../entity/Staff';
import { AppSettings } from './app.setting';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class MailsService {
 
  private baseUrl: string = environment.restApi+ 'mails';
  private baseUrl1: string = environment.restApi;
  private baseUrl1Erp: string = environment.restApi;
  constructor(private http: HttpClient) { }

  upload(file: FormData): Observable<Response> {

    return this.http.post<Response>(`${this.baseUrl}/upload`, file);
  }

  uploadModel(file: FormData): Observable<Response> {
 

    return this.http.post<Response>(`${this.baseUrl1}detailprojet/upload`, file);
  }


  removeByPjoint(idPjoint:number): Observable<Response>   {
   return  this.http.delete<Response>(`${this.baseUrl1}detailprojet/removeByPjoint/`+idPjoint) 
  }

  get(id: number): Observable<Mails> {
    let Mails$ = this.http
      .get<Mails>(`${this.baseUrl}/` + id ) ;


    return Mails$;
  }

  pjointFile(pjoint: Pjoint): any {

    // let pjoint$ = this.http.get<Modelcores>(`${this.baseUrl1}pjoint/findPjoint/` + pjoint.pjointeId )
    // return pjoint$;
   //}
   const pjoint$ = this.http.get (`${this.baseUrl1}pjoint/findPjoint/find/pjoint/crm/nouveau/${pjoint.pjointeId}`  , { responseType: "blob"}     )  ;
     return pjoint$;
   }
 
 


  createDraft(mails: Mails): Observable<Mails> {
    mails.type = 'Draft';
    return this.http.post<Mails>(`${this.baseUrl}/createDraft`, mails );
  }
  editDraft(mails: Mails): Observable<Mails> {
    mails.type = 'Draft';
    return this.http.put<Mails>(`${this.baseUrl}/editDraft`, mails );
  }

  connect(mail: String, pass: String): Observable<any> {

    return this.http.get (`${this.baseUrl}/connect/${mail}/${pass}` );
  }
  applicat(mailAdd: string,passWord: string) {
    let mails$;
    if (mailAdd) {
      

      mails$ = this.http.get<any>(`${this.baseUrl1}applicat/readMails/${mailAdd}/${passWord}` );
    }

    return mails$;
  }
  refreshMails(refreshMails: string, mailAdd: string,mailPass:string) {

 

    let mails$ = this.http.get<any>(`${this.baseUrl1}applicat/${refreshMails}/${mailAdd}/${mailPass}` );
    return mails$;
  }
/*
  readMails(prospect: Prospect, mailAdd: string): Observable<Mails[]> {
    let mails$;

      mails$ = this.http.get(`${this.baseUrl}/readMailsProspect/${prospect.prospectid}/${mailAdd}`, { headers: this.getHeaders() }).map(mapMails);
    return mails$;
  }*/

  findMailsSentProspect(prospect: Prospect, mailAdd: string): Observable<Mails[]> {
    let mails$;

      mails$ = this.http.get<Mails[]>(`${this.baseUrl}/findMailsSentProspect/${prospect.prospectId}/${mailAdd}` );
    return mails$;
  }

  findMailsRecuProspect(prospect: Prospect, mailAdd: string): Observable<Mails[]> {
    let mails$;

      mails$ = this.http.get<Mails[]>(`${this.baseUrl}/findMailsRecuProspect/${prospect.prospectId}/${mailAdd}` );
    return mails$;
  }

  //searchMail/{mailAdd}/{type}/{key}

  searchMail(type: string, key: string, mailAdd: string): Observable<Mails[]> {

    let passWord: string = localStorage.getItem(mailAdd);
    let mails$ = this.http.get<Mails[]>(`${this.baseUrl1}mailsFunc/searchMail/${mailAdd}/${type}/${key}` );
    return mails$;
  }
  readMailsUserRange(type: string, from: number, to: number, mailAdd: string): Observable<Mails[]> {

    let mails$ = this.http.get<Mails[]>(`${this.baseUrl}/${mailAdd}/${type}/${from}/${to}` );
    return mails$;
  }

  findTotalUser(type: string, mailAdd: string): Observable<any> {

    let mails$ = this.http.get<Mails[]>(`${this.baseUrl1}mailsFunc/totalType/${mailAdd}/${type}` );
    return mails$;
  }
  findTotalUnread(type: string, mailAdd: string): Observable<any> {

    let mails$ = this.http.get<any>(`${this.baseUrl1}mailsFunc/totalUnread/${mailAdd}/${type}` ); 
    return mails$;
  }




  mailPjoints(mails: Mails): Observable<Pjoint[]> {
    let pjoint$ = this.http.get<Pjoint[]>(`${this.baseUrl}/mailsPjoint/` + mails.idMails );
    return pjoint$;
  }

  modelPjoints(): Observable<Pjoint[]> {
    let pjoint$ = this.http.get<Pjoint[]>(`${this.baseUrl1}pjoint/modelPjoint` );
    return pjoint$;
  }
  modelsCorespAll( ): Observable<Modelcores[]> {
    let Modelcores$ = this.http.get<Modelcores[]>(`${this.baseUrl1Erp}modelcores` );
    return Modelcores$;
  }
  modelsCoresp(projet: string): Observable<Modelcores[]> {
    let Modelcores$ = this.http.get<Modelcores[]>(`${this.baseUrl1Erp}modelcores/findByProject/${projet}` );
    return Modelcores$;
  }
  findodel(idModel:number): Observable<Modelcores> {
    let Modelcores$ = this.http.get<Modelcores>(`${this.baseUrl1Erp}modelcores/` + idModel );
    return Modelcores$;
  }
  modelCoresp(modelCoresp: Modelcores): Observable<Modelcores> {
    let Modelcores$ = this.http.get<Modelcores>(`${this.baseUrl1Erp}modelcores/` + modelCoresp.modelcoresId );
    return Modelcores$;
  }





  save(mails: Mails): Observable<Response> {
    //console.log(this.baseUrl + '/' + mails.idMails + "edit" + mails.read);

    return this.http.put<Response>(this.baseUrl + '/' + mails.idMails, JSON.stringify(mails) );
  }
  private getHeaders1() {
    let headers = new Headers();
    headers.append('Accept', 'application/pdf');

    headers.append("Content-Type", "application/pdf");

    return headers;
  } private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return headers;
  }




}
function mapPjoint(response: Response): Pjoint[] {
  return response.json().map(toPjoint);
}
function toPjoint(r: any): Pjoint {
  return r;
}
function mapModelcore(response: Response): Modelcores {
  return toModelcores(response.json());
}

function mapModelcores(response: Response): Modelcores[] {
  return response.json().map(toModelcores);
}
function toModelcores(r: any): Modelcores {
  return r;
}
function mapMail(response: Response): Mails {
  return toMail(response.json());
}
function mapMails(response: Response): Mails[] {
  return response.json().map(toMail);
}
function toMail(r: any): Mails {
  return r;
}
